<p-tabView
  [styleClass]="
    styleClass +
    ' ' +
    (alignment === 'left' ? 'tabview-left' : 'tabview-center')
  "
  [(activeIndex)]="activeIndex"
  (onChange)="onTabChange($event)"
  [scrollable]="scrollable"
>
  <p-tabPanel *ngFor="let tab of tabs; let i = index" [header]="tab.header">
    <ng-container *ngIf="tab.contentTemplate">
      <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
    </ng-container>
    <ng-content *ngIf="!tab.contentTemplate"></ng-content>
  </p-tabPanel>
</p-tabView>
